'use client';

import { useEffect } from 'react';

const STORAGE_KEY = 'cookieConsent';

// Extend window type for Google Analytics
declare global {
    interface Window {
        dataLayer: unknown[];
        gtag: (...args: unknown[]) => void;
    }
}

export default function GoogleAnalytics() {
    useEffect(() => {
        const handleConsent = () => {
            try {
                const raw = localStorage.getItem(STORAGE_KEY);
                if (!raw) return;
                const consent = JSON.parse(raw);

                if (typeof window.gtag === 'function') {
                    // Update consent based on user's choice
                    window.gtag('consent', 'update', {
                        'analytics_storage': consent?.analytics ? 'granted' : 'denied'
                    });
                }
            } catch (e) {
                console.error('Failed to update GA consent:', e);
            }
        };

        // Check consent on mount
        handleConsent();

        // Listen for consent changes
        const onStorage = (e: StorageEvent) => {
            if (e.key === STORAGE_KEY) handleConsent();
        };

        const onConsentChanged = () => handleConsent();

        window.addEventListener('storage', onStorage);
        window.addEventListener('cookieConsentChanged', onConsentChanged as EventListener);

        return () => {
            window.removeEventListener('storage', onStorage);
            window.removeEventListener('cookieConsentChanged', onConsentChanged as EventListener);
        };
    }, []);

    return null;
}
